<div
  class="header pb-7 pt-5 pt-lg-7 d-flex align-items-center"
  style="
    min-height: 120px;
    background-size: cover;
    background-position: center top;
  "
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="text-white">Últimas compras com cashback</h1>
        <p class="text-white mt-0 mb-5">
          Visualiza todas as compras com check-in feitas.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
      <div class="card card-profile shadow">
        <div class="row justify-content-center">
          <div class="col-lg-3 order-lg-2">
            <div
              class="card-profile-image avatar-grande rounded-circle mr-3"
              [style.background-image]="
                'url(' +
                (recentCheckin?.customer?.photoURL ||
                  '/assets/img/default-avatar.png') +
                ')'
              "
              [style.background-size]="'cover'"
              [style.background-position]="'center'"
            ></div>
          </div>
        </div>
        <div class="card-body pt-0 pt-md-4">
          <div class="text-center mt-8">
            <h3>
              {{
                (recentCheckin?.customer?.nomeCompleto | titlecase) ||
                  "Cliente não encontrado"
              }}
            </h3>
            <div class="h5 font-weight-300">
              <i class="ni location_pin mr-2"></i>
              {{
                recentCheckin?.dateTime?.toDate() | date : "dd/MM/yyyy HH:mm:ss"
              }}
            </div>
            <hr class="my-4" />
            <p>Este foi o último check-in válido</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-8 order-xl-1">
      <div class="card shadow">
        <div class="card-header border-0">
          <h3 class="mb-0">Últimos 10 Check-Ins</h3>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col">Cliente</th>
                <th scope="col">Status</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loading State -->
              <tr *ngIf="loading">
                <td colspan="3" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Carregando...</span>
                  </div>
                  <p class="mt-2 mb-0">Carregando compras...</p>
                </td>
              </tr>

              <!-- Error State -->
              <tr *ngIf="error && !loading">
                <td colspan="3" class="text-center py-4">
                  <div class="alert alert-danger mb-0">
                    <i class="ni ni-notification-70"></i> {{ error }}
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr *ngIf="checkins?.length === 0 && !loading && !error">
                <td colspan="3" class="text-center py-4">
                  <div class="alert alert-info mb-0">
                    <i class="ni ni-info-circle"></i> Nenhuma compra encontrada.
                  </div>
                </td>
              </tr>

              <!-- Data Rows -->
              <tr
                *ngFor="let item of checkins; trackBy: trackByFn"
                [ngClass]="cashbackService.rowClass(item)"
              >
                <td scope="row">
                  <div class="media align-items-center">
                    <a
                      href="javascript:void(0)"
                      class="avatar rounded-circle mr-3"
                      [style.background-image]="
                        'url(' +
                        (item?.customer?.photoURL ||
                          '/assets/img/default-avatar.png') +
                        ')'
                      "
                      [style.background-size]="'cover'"
                      [style.background-position]="'center'"
                    >
                    </a>
                    <div class="media-body">
                      <strong class="mb-0">
                        {{
                          (item?.customer?.nomeCompleto | titlecase) ||
                            "Cliente não encontrado"
                        }}
                      </strong>
                      <br />
                      <small class="text-muted">
                        {{
                          item?.dateTime?.toDate()
                            | date : "dd/MM/yyyy HH:mm:ss"
                        }}
                      </small>
                      <br />
                      <div class="mt-1">
                        <span class="text-sm">
                          <strong>Compra:</strong>
                          {{
                            item.valor | currency : "BRL" : "symbol" : "1.2-2"
                          }}
                        </span>
                        <br />
                        <span class="text-sm">
                          <strong>Cashback:</strong>
                          {{
                            item.cashback
                              | currency : "BRL" : "symbol" : "1.2-2"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <span
                    class="badge badge-pill"
                    [ngClass]="cashbackService.statusBadgeClass(item)"
                  >
                    <i
                      class="ni"
                      [ngClass]="cashbackService.statusIconClass(item)"
                    ></i>
                    {{ cashbackService.statusLabel(item) }}
                  </span>
                </td>

                <td>
                  <div class="cashback-actions" role="group">
                    <button
                      type="button"
                      (click)="verImagem(item?.imagem)"
                      class="btn btn-sm btn-outline-secondary"
                      title="Ver comprovante"
                      [disabled]="!item?.imagem"
                    >
                      <i class="ni ni-image"></i
                      ><span class="btn-label"> Ver comprovante</span>
                    </button>

                    <button
                      *ngIf="cashbackService.isPendente(item)"
                      type="button"
                      (click)="aprovar(item?.id)"
                      class="btn btn-sm btn-success"
                      title="Aprovar cashback"
                    >
                      <i class="ni ni-check-bold"></i
                      ><span class="btn-label"> Aprovar</span>
                    </button>

                    <button
                      *ngIf="cashbackService.isPendente(item)"
                      type="button"
                      (click)="rejeitar(item?.id)"
                      class="btn btn-sm btn-danger"
                      title="Rejeitar cashback"
                    >
                      <i class="ni ni-fat-remove"></i
                      ><span class="btn-label"> Rejeitar</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
